<app-form-dialog-shell
  [icon]="isEditing ? 'edit' : 'add_circle'"
  [heading]="isEditing ? 'Editar permiso' : 'Nuevo permiso'"
  [saving]="saving()"
  [saveLabel]="isEditing ? 'Guardar cambios' : 'Crear permiso'"
  [saveIcon]="isEditing ? 'save' : 'add'"
  formId="permission-form"
  (cancelled)="close()"
  >
<form id="permission-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="basic-grid">

        <mat-form-field appearance="outline">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name" placeholder="ej. CREAR" />
          <mat-icon matPrefix>label</mat-icon>
          <mat-hint>Se guardará en mayúsculas</mat-hint>
          @if (fieldError('name')) {<mat-error>Nombre requerido (mín. 2 caracteres)</mat-error>}
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-col">
          <mat-label>Descripción</mat-label>
          <input matInput formControlName="description"
            placeholder="ej. Capacidad de crear elementos" />
          <mat-icon matPrefix>description</mat-icon>
          @if (fieldError('description')) {<mat-error>Descripción requerida</mat-error>}
        </mat-form-field>

        <div class="toggle-row full-col">
          <mat-slide-toggle formControlName="active" color="primary">
            Permiso activo
          </mat-slide-toggle>
          <span class="toggle-hint">Los permisos inactivos no pueden asignarse a roles</span>
        </div>

      </div>

      </form>
</app-form-dialog-shell>
